// extracted by mini-css-extract-plugin
export default {"allocating":"List_allocating__kTEpK","actions":"List_actions__mXvlR","button":"List_button__TZpoz"};